import React, {Component} from 'react';
import ReactDOM from "react-dom";
import $ from "jquery";


class Countdown extends Component {
    constructor() {
        super();

    }
    componentDidMount(){
        var chrome   = navigator.userAgent.indexOf('Chrome') > -1;
        var explorer = navigator.userAgent.indexOf('MSIE') > -1;
        var firefox  = navigator.userAgent.indexOf('Firefox') > -1;
        var safari   = navigator.userAgent.indexOf("Safari") > -1;
        var camino   = navigator.userAgent.indexOf("Camino") > -1;
        var opera    = navigator.userAgent.toLowerCase().indexOf("op") > -1;
        if ((chrome) && (safari)) safari = false;
        if ((chrome) && (opera)) chrome = false;
        // if (safari) alert('safari');
        if (safari) document.getElementById('timer').style.display = 'none';



        function makeTimer() {

            var endTime = new Date("October 27, 2018 10:00:00 PDT");
            var endTime = (Date.parse(endTime)) / 1000;

            var now = new Date();
            var now = (Date.parse(now) / 1000);

            var timeLeft = endTime - now;

            var days = Math.floor(timeLeft / 86400);
            var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
            var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
            var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

            if (hours < "10") { hours = "0" + hours; }
            if (minutes < "10") { minutes = "0" + minutes; }
            if (seconds < "10") { seconds = "0" + seconds; }

            $("#days").html(days + "<span></span>");
            $("#hours").html(hours + "<span></span>");
            $("#minutes").html(minutes + "<span></span>");
            $("#seconds").html(seconds + "<span></span>");

        }

        setInterval(function() { makeTimer(); }, 1000);
    }

    render() {

        return (
            <div>
                <div className="section --coundown black block-4 z-11 p-40 mb-2">
                    <div className="container relative-text p-40">
                        <div className="row mb0">
                            <div className="col s12 center-align">
                                <h1 className="f-38 white-text bold-text text-uppercase">7-DAY MUSIC & INNOVATION FESTIVAL</h1>
                            </div>
                            <div className="col s12 center-align">
                                <div className="hide-on-med-and-up">
                                    <h1 className="f-38 white-text bold-text text-uppercase">October <br className="hide-on-med-and-up" /> 20th - 27th</h1>
                                </div>
                                <div className="hide-on-small-only">
                                    <div className="row" id="timer">
                                        <div className="col s2 offset-s2"><div className="transparent black-text clock-square" id="days"></div><span className="clock-label black-text text-uppercase">Days</span></div>
                                        <div className="col s2"><div className="transparent bold clock-square" id="hours"></div><span className="clock-label black-text text-uppercase">Hours</span></div>
                                        <div className="col s2"><div className="transparent clock-square" id="minutes"></div><span className="clock-label black-text text-uppercase">Mins</span></div>
                                        <div className="col s2"><div className="transparent clock-square" id="seconds"></div><span className="clock-label text-uppercase">Secs</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default Countdown;


// WEBPACK FOOTER //
// ./src/components/countdown.js